<template>
	<!-- Search Input -->
	<form
		class="spofaq-searchapp__form"
		id="Search"
		v-on:submit.prevent="onSubmit"
		autocomplete="off"
	>
		<fieldset aria-label="search" role="search" class="spofaq-searchapp__fieldset">
			<input
				class="spofaq-searchapp__input"
				:value="value"
				@input="$emit('input', $event.target.value)"
				:placeholder="placeholder"
				type="search"
				id="faq-search"
				ref="search"
			/>
			<label for="faq-search" class="spofaq-searchapp__label">{{
				placeholder
			}}</label>
			<input type="submit" class="visually-hidden" />
		</fieldset>
	</form>
	<!-- End Search Input -->
</template>

<script>
export default {
	name: "SearchForm",
	props: ["placeholder", "value"],
	methods: {
		onSubmit() {
			 this.$refs.search.blur();
		}
	}	
};
</script>
